import React from 'react';
import styles from './smart-records-panel.module.css';
import { type SmartRecordCreatableType } from '../../types';
import { RECORD_ICONS } from '../../utils/record';
import ShapeSmartRecord from '../../shapes/ShapeSmartRecord';
import type Shape from '../../objects/Shape';
import classNames from 'classnames';

// Try to use the lightest shade in the same color. For now, we don't have any
// clashes, but some record types do share a primary color (e.g., goals and
// strategic imperatives both use teal, but we don't support the latter right now).
export const pillBackgroundColors: Record<SmartRecordCreatableType, string> = {
  epics: 'var(--aha-purple-100)',
  features: 'var(--aha-blue-100)',
  goals: 'var(--aha-teal-100)',
  ideas: 'var(--aha-green-100)',
  initiatives: 'var(--aha-pink-100)',
  releases: 'var(--aha-gray-400)', // aha-gray-100 is really light on a white background
  requirements: 'var(--aha-orange-100)',
};

const SmartRecordTitle: React.FC<{ record: Shape<ShapeSmartRecord> }> = ({
  record,
}) => {
  const recordType = record.recordType as SmartRecordCreatableType;
  return (
    <div className={styles.recordTitle}>
      <div
        className={styles.recordPill}
        style={{
          backgroundColor: pillBackgroundColors[recordType],
        }}
      >
        <i
          style={{ color: 'white' }}
          className={`record-reference-pill__icon record-reference-pill__icon--${record.shape.recordTypename.toLowerCase()} ${
            RECORD_ICONS[record.shape.recordTypename]
          }`}
        />
        <div className={classNames(styles.truncatedName, styles.pillName)}>
          {ShapeSmartRecord.terminologyFor(recordType)}
        </div>
      </div>
      <div>{record.plainText()}</div>
    </div>
  );
};

export default SmartRecordTitle;
